<template>
  <div class="city-region-tab">
    <city-tag
      v-for="(item,index) in list"
      :key="item[valueKey]"
      @click="handleClickCityRegionTab(item,index)"
      :closable="closable"
      @close="handleRemoveCityRegionTab(item[valueKey])"
      :is-active="currentValue === item[valueKey]"
      class="city-region-tab--item"
    >
      <span class="label">{{item.label|| joinCityNameText(item.cityList)||"请选择城市"}}</span>
    </city-tag>
    <el-button
      v-if="openAdded"
      type="text"
      plain
      size="small"
      icon="el-icon-plus"
      @click="handleAddedCityRegionTab"
      class="city-region-tab--added">新增</el-button>
  </div>
</template>

<script>
import {baseDataCityListRegionHeaderItem} from "@/components/QuotationManagement/components-productQuotation/productQuotation";
import CityTag from "@/components/QuotationManagement/components-productQuotation/city-tag";

export default {
  name: "cityTabsRow",
  components: {CityTag},
  props:{
    list:{// tab list
      type:Array,
      default:()=>[],
    },
    valueKey:{
      type:String,
      default:"_id",
    },
    defaultCurrentValue:{
      type:[String,Number],
      default:"",
    },
    closable:Boolean,
    openAdded:Boolean,
  },
  data(){
    return {
      currentValue:"",
    }
  },
  watch:{
    defaultCurrentValue:{
      immediate:true,
      handler(newVal){
        this.currentValue = newVal;
      }
    },
  },
  methods:{
    /**
     * 切换 tab
     * @param item
     * @param index
     */
    handleClickCityRegionTab(item,index){
      let value = item[this.valueKey];
      this.setCurrentValue(value);
    },
    setCurrentValue(value){
      this.currentValue = value;
      this.$emit("update:defaultCurrentValue",value);
      this.$emit("change",value);
    },
    /**
     * 新增城市维度区间tabItem
     */
    handleAddedCityRegionTab(){
      let item = baseDataCityListRegionHeaderItem();
      let value = item[this.valueKey];
      this.list.push(item);
      this.$emit("added",item,this.list.length-1);
      this.setCurrentValue(value);
    },
    /**
     * 移除城市维度区间tabItem
     * @param targetName  {number|string} 被删除的标签的name(即标识id)
     */
    handleRemoveCityRegionTab(targetName){
      let index = this.list.findIndex(item=>item[this.valueKey] === targetName);
      if(index >= 0) this.list.splice(index,1);
      this.$emit("remove");
      if(this.list.length){
        let item = this.list[this.list.length - 1];
        let value = item[this.valueKey];
        this.setCurrentValue(value);
      }else{
        this.setCurrentValue("");
      }
    },
    /**
     * 拼接起运城市文本
     * @param list
     * @returns {string}
     */
    joinCityNameText(list = []){
      return list.map(item=>item.cityName).join(",");
    },
  }
}
</script>

<style scoped lang="scss">
.city-region-tab{
  position: relative;
  z-index: 1;
  &--item,
  &--added{
    //margin-right: 10px;
    margin-bottom: 15px;
    vertical-align: middle;
  }
  &--item{
    overflow: hidden;
    border-radius: 0 !important;
    .label{
      display: inline-block;
      vertical-align: middle;
      max-width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  &--added{
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/cityTabsRow/index.vue